import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'body',
  template: '<app-root></app-root>'
})
export class BodyComponent {
  @HostBinding('class') public bodyClass: string;
}



// WEBPACK FOOTER //
// ./src/app/body.component.ts